import * as Sentry from '@sentry/react'
import { APP_ENV } from './env'

export const initSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  // no DSN (local builds) leaves the SDK disabled entirely
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: APP_ENV,
    release: (import.meta.env.VITE_APP_VERSION as string | undefined) || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    sendDefaultPii: false,
  })
}

// id only — never email or other PII
export const setSentryUser = (id: string | null): void => {
  Sentry.setUser(id ? { id } : null)
}
